import { useCallback } from "react";
import { Channel, DialogType, Topic } from "../constants";
import { MessageBrokerUtils } from "../utils";

export const useLocationHandler = () => {
  const openStateSwitcherPopup = useCallback(() => {
    MessageBrokerUtils.publish({
      channel: Channel.UI,
      topic: Topic.DialogShow,
      headers: { publisher: "UAA" },
      data: {
        dialogType: DialogType.StateSwitcher
      }
    });
  }, []);

  const openConfirmLocationPopup = useCallback(() => {
    MessageBrokerUtils.publish({
      channel: Channel.UI,
      topic: Topic.DialogShow,
      headers: { publisher: "UAA" },
      data: {
        dialogType: DialogType.ConfirmLocation
      }
    });
  }, []);

  const openLocationConfirmationPopup = useCallback(() => {
    MessageBrokerUtils.publish({
      channel: Channel.UI,
      topic: Topic.DialogShow,
      headers: { publisher: "UAA" },
      data: {
        dialogType: DialogType.LocationConfirmation
      }
    });
  }, []);

  const sendLocationConfirmation = useCallback(({ isConfirmed }) => {
    MessageBrokerUtils.publish({
      channel: Channel.PLAYER,
      topic: Topic.confirmLocation,
      headers: { publisher: "UAA" },
      data: { isConfirmed }
    });
  }, []);

  return {
    openStateSwitcherPopup,
    openConfirmLocationPopup,
    openLocationConfirmationPopup,
    sendLocationConfirmation
  };
};
